module.exports = __webpack_public_path__ + "img/milc-snow-text.417200c8.png";